import "./../scss/main.scss";
import "./../scss/solutions.scss";
import "./../scss/eligibleForm.scss";

import "bootstrap";
